var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MenuCount_Stock'),_c('Count_Stock')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }